import { gql } from 'apollo-client-ppc';
import { commonCommerceAddress, commonPaymentMethods } from '@css-xp/ppc-common/src/fragments/fragments';

export const fetchInvoiceGroupQueryPPC = gql`
  ${commonPaymentMethods}
  ${commonCommerceAddress}
  query fetchInvoiceGroupPPC($id: ID!, $txaId: ID) {
    invoiceGroup(id: $id, txaId: $txaId) {
      id
      name
      currency
      updatePaymentMethodLink
      transactionAccountId
      transactionAccountNumber
      invoiceGroupNumber
      termPaymentStatus {
        status
      }
      shipToParty {
        ...commerceAddressFields
        shipToPriceEligibility
        isActive
      }
      defaultPaymentMethod {
        ...paymentMethodFields
      }
      transactionAccount {
        id
        displayName
        updatePaymentMethodLink
        partnerAccountId
        billToParty {
          ...commerceAddressFields
        }
        availablePaymentMethods {
          totalCount
          nodes {
            ...paymentMethodFields
          }
        }
      }
      isActive
      recipients
      purchaseOrder {
        number
        oneTimeUse
      }
    }
  }
`;
